export enum RequirementStatus {
	APPROVED = 'APPROVED',
	PENDING = 'PENDING',
	VERIFIED = 'VERIFIED',
	DEPLOYED = 'DEPLOYED',
	COMPLETED = 'COMPLETED',
	SUBMITTED = 'SUBMITTED',
}
